import { Modal } from 'antd';

interface ModalConfirmProps {
    title?: React.ReactNode;
    content?: React.ReactNode;
    cancelText?: React.ReactNode;
    onCancel?: (...args: any[]) => any;
    okText?: React.ReactNode;
    onOk?: (...args: any[]) => any;
}

export const onModalConfirm = (iprops: ModalConfirmProps) => {
    Modal.confirm({
        title: iprops.title || 'Confirmação Envio de Email',
        content: iprops.content || 'Você deseja enviar este e-mail?',
        cancelText: iprops.cancelText || "Não",
        onCancel: iprops.onCancel,
        okText: iprops.okText || 'Sim',
        onOk: iprops.onOk,
        maskClosable: true
    });
};